import { action } from '@reatom/framework'

import { dependenciesAtom } from '@root/features/shared/dependencies'
import { reatomRequest } from '@root/shared/lib'

export const reatomGenerateMnemonic = () => {
  const generateMnemonicAction = action(async (ctx) => {
    const { secureStorageService } = ctx.get(dependenciesAtom)
    const mnemonicResult = await ctx.schedule(() =>
      secureStorageService.generateMnemonic(),
    )
    return mnemonicResult
  }, 'generateMnemonicAction')

  const state = reatomRequest({
    execAction: generateMnemonicAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'generateMnemonicAction',
  })

  return state
}
